<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/entradaNF', query: $route.query }"> Almoxarifado/Entrada de Nfes </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Visualizar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="3" class="text-left">
            <v-menu
              v-model="menuData1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDataEmissao"
                  label="Data Emissão"
                  prepend-icon="mdi-calendar"
                  v-mask="['##/##/####']"
                  maxlength="10"
                  v-bind="attrs"
                  v-on="on"
                  @input="onInputDate1"
                  @click:clear="dataEmissao = null"
                  :clearable="!readOnly"
                  :readonly="readOnly"
                  :rules="[(v) => !!v || 'A data inicial é obrigatória']"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataEmissao"
                @input="menuData1 = false"
                @change="dateChangeDataEmissao"
                locale="pt-br"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Nota Fiscal nº*"
              v-model="numero"
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Número é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-select
            v-model="fornecedorSelected"
            :items="filteredFornecedor"
            label="Fornecedor *"
            item-text="nome"
            item-value="id"
            persistent-hint
            return-object
            :rules="[(v) => !!v || 'O Fornecedor é obrigatório']"
            required
            :readonly="(pedidosNF != null || readOnly)"
          >
          </v-select>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-select
              v-model="unidadeAdmSelected"
              :items="locais"
              item-value="id"
              item-text="descricao"
              label="Unidade Adm"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Unidade Adm é obrigatória']"
              required
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="condicaoPagamentoSelected"
              :items="condicoes"
              item-value="id"
              item-text="descricao"
              label="Pagamento"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Pagamento é obrigatório']"
              required
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              clearable
              auto-grow
              clear-icon="mdi-close-circle"
              label="Informações Adicionais"
              v-model="informacoes"
              maxlength="200"
              :readonly="readOnly"
              counter
              rows="1"
              :rules="[
                (v) =>
                  !v ||
                  v.length <= 200 ||
                  'Informações Adicionais deve possuir no máximo 200 caracteres',
              ]"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-snackbar v-model="errorMessage" color="error" timeout="3000"
          >{{ errorMessageValue }}
        </v-snackbar>
      </v-form>

      <v-row align="center" >
        <v-col class="text-right">
          <v-tooltip bottom v-if="!(pedidosNF != null) && !readOnly">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addProduto()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar produto</span>
          </v-tooltip>
          <v-tooltip bottom v-if="!readOnly">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="selecionarPedido()"
                class="white--text ml-2"
              >
                <v-icon> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span>Pesquisar pedidos</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-form ref="formProd" v-model="valid" lazy-validation 
              :readonly="readOnly">
        <v-card>
          <v-data-table
            :headers="headers"
            hide-default-footer
            :items-per-page="-1"
            :items="produtosL"
          >
            <template v-slot:item.centroCusto="{ item }">
              <div v-if="!item.editingCentroCusto">
                <div
                  @click="item.editingCentroCusto = true"
                  style="cursor: pointer"
                >
                  {{
                    (item.centroCustoSelected &&
                      item.centroCustoSelected.descricao) ||
                    "Selecionar..."
                  }}
                </div>

                <div
                  v-if="item.centroCustoErro"
                  style="color: #b00020; font-size: 12px"
                >
                  O Centro de Custo Ã© obrigatÃ³rio
                </div>
              </div>
              <v-autocomplete
                v-else
                v-model="item.centroCustoSelected"
                :items="centrosCusto"
                item-text="descricao"
                item-value="id"
                return-object
                :readonly="pedidosNF != null"
                autofocus
                @blur="
                  () => {
                    item.editingCentroCusto = false;
                    item.centroCustoErro = !(
                      item.centroCustoSelected && item.centroCustoSelected.id
                    );
                  }
                "
                @change="
                  (val) => {
                    changeProduto(item.index, val);
                    item.centroCustoErro = !(val && val.id);
                    item.editingCentroCusto = false;
                  }
                "
                :rules="[
                  (v) => !!(v && v.id) || 'O Centro de Custo é obrigatório',
                ]"
                required
              >
              </v-autocomplete>
            </template>
            <template v-slot:item.idPedido="{ item }">
              <span v-if="item.idPedido">
                {{ item.idPedido }}
              </span>
              <span v-else>-</span>
            </template>
            <template v-slot:item.produto="{ item }">
              <span v-if="item.produto">
                {{ item.produto }}
              </span>
              <span v-else>{{ item.descricao }}</span>
            </template>
            <template v-slot:item.quantidade="{ item }">
              <v-text-field
                :value="item.quantidade"
                :readonly="readOnly"
                type="number"
                min="1"
                step="1"
                :max="item.quantidadePendente || undefined"
                @input="(val) => onInputQuantidade(val, item)"
                @change="(val) => onInputQuantidade(val, item)"
              />
            </template>
            <template v-slot:item.valorUnitario="{ item }">
              <v-text-field
                :value="item.valorUnitarioLocal"
                :readonly="readOnly"
                @input="(val) => onInput(val, item, 'valorUnitario')"
                type="text"
              />
            </template>
            <template v-slot:item.desconto="{ item }">
              <v-text-field
                :value="item.descontoLocal"
                :readonly="readOnly"
                @input="(val) => onInput(val, item, 'desconto')"
                type="text"
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom v-if="pedidosNF == null">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="error"
                    @click="removeProduto(item.index)"
                    v-bind="attrs"
                    v-on="on"
                    :disabled="readOnly"
                  >
                    mdi-close-thick
                  </v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
        <v-row align="center">
          <v-col cols="12" sm="7"> </v-col>
          <v-col cols="12" sm="2">
            <v-label class="text-right d-block">Subtotal:</v-label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              @input="calcularTotais()"
              v-model="subtotal"
              class="mt-0 pt-0"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="7"> </v-col>
          <v-col cols="12" sm="2">
            <v-label class="text-right d-block">Acréscimo:</v-label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="acrescimoLocal"
              @input="(val) => onInput(val, null, 'acrescimo')"
              class="mt-0 pt-0"
              type="text"
            />
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="12" sm="7"></v-col>
          <v-col cols="12" sm="2">
            <v-label class="text-right d-block">Desconto:</v-label>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="descontoLocal"
              @input="(val) => onInput(val, null, 'descontoadd')"
              class="mt-0 pt-0"
              type="text"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="7"></v-col>
          <v-col cols="12" sm="5"> <v-divider></v-divider> </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="12" sm="7"></v-col>
          <v-col cols="12" sm="2">
            <v-label class="text-right d-block font-weight-bold"
              >Total:</v-label
            >
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="total"
              class="mt-0 pt-0"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn :to="{ path: '/entradaNF', query: $route.query }" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Produto</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <produto
                ref="prdAdd"
                :produtosL="produtosL"
                :showModal="showModal"
              />
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      style="z-index: 9999"
      v-model="showModalFornecedor"
      persistent
      max-width="1200px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Pesquisar Pedidos</span>
        </v-card-title>
        <v-card-text>
          <fornecedor
            :itens="pedidosEntrada"
            @adicionar="onAdicionarPedido"
          />
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModalFornecedor = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { editarEntradaNFAsync } from "../../../services/entradaNFService";
import { mapState, mapActions } from "vuex";
import Produto from "./Produto";
import Fornecedor from "./Fornecedor";
import moment from "moment";
import {
  descontoOriginalItemPedido,
  descontoProporcionalItemPedido,
  quantidadeOriginalPedido,
  resumoEntrada,
  totalItemEntrada,
} from "./calculosEntradaNF";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "criarEntradaNF",
  data: () => ({
    overlay: false,
    valid: true,
    numero: null,
    showModal: false,
    showModalFornecedor: false,
    informacoes: null,
    localSelected: null,
    produtosL: [],
    indexEdit: null,
    fornecedorSelected: null,
    unidadeAdmSelected: null,
    dataEmissao: null,
    menuData1: false,
    active_tab: 2,
    desconto: 0,
    acrescimo: 0,
    descontoLocal: null,
    acrescimoLocal: null,
    subtotal: 0,
    total: 0,
    errorMessage: false,
    errorMessageValue: null,
    readOnly: false,
    headers: [
      { text: "Pedido", value: "idPedido", sortable: false },
      { text: "Produto/Serviço", value: "produto", sortable: false },
      { text: "Quantidade", value: "quantidade", width: "10%" },
      { text: "Centro de Custo", value: "centroCusto", sortable: false },
      { text: "Valor Unit", value: "valorUnitario", sortable: false },
      { text: "Desconto", value: "desconto", sortable: false },
      { text: "Total", value: "total", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("entradaNF", ["entradasNF", "pedidosNF", "entradaNF"]),
    ...mapState("pedido", ["pedidosEntrada"]),
    ...mapState("fornecedor", ["fornecedores", "fornecedor"]),
    ...mapState("condicaoPagamento", ["condicoes"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    computedDataEmissao() {
      return this.dataEmissao
        ? moment(this.dataEmissao).format("DD/MM/YYYY")
        : null;
    },
    filteredFornecedor() {
      return this.fornecedores
        .filter((f) => {
          return f.ativo === true;
        })
        .sort(function (a, b) {
          return b.id - a.id;
        });
    },
  },
  methods: {
    ...mapActions("produto", ["atualizarListaProdutos"]),
    ...mapActions("pedido", ["atualizarPedidosEntrada"]),
    onInput(valorDigitado, item, propriedade) {
      const apenasNumeros = valorDigitado.replace(/\D/g, "");
      switch (propriedade) {
        case "valorUnitario":
          item.valorUnitario = apenasNumeros;
          if (!item.valorUnitario || isNaN(item.valorUnitario)) {
            item.valorUnitario = "";
            return;
          }
          const valorNumericoU = parseFloat(item.valorUnitario) / 100;
          item.valorUnitario = valorNumericoU;
          item.valorUnitarioLocal = valorNumericoU.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.calcularSubtotais(item);
          break;
        case "desconto":
          item.desconto = apenasNumeros;
          if (!item.desconto || isNaN(item.desconto)) {
            item.desconto = "";
            return;
          }
          const valorNumericoP = parseFloat(item.desconto) / 100;
          item.desconto = valorNumericoP;
          item.descontoLocal = valorNumericoP.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          item.descontoOriginalItem = valorNumericoP;
          item.quantidadeOriginalPedido = Number(item.quantidade || 0);
          this.calcularSubtotais(item);
          break;
        case "acrescimo":
          this.acrescimo = apenasNumeros;
          if (!this.acrescimo || isNaN(this.acrescimo)) {
            this.acrescimo = "";
            return;
          }
          const valorNumericoA = parseFloat(this.acrescimo) / 100;
          this.acrescimo = valorNumericoA;
          this.acrescimoLocal = valorNumericoA.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.calcularTotais();
          break;
        default:
          this.desconto = apenasNumeros;
          if (!this.desconto || isNaN(this.desconto)) {
            this.desconto = "";
            return;
          }
          const valorNumericoDa = parseFloat(this.desconto) / 100;
          this.desconto = valorNumericoDa;
          this.descontoLocal = valorNumericoDa.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          this.calcularTotais();
          break;
      }
    },
    calcularSubtotais(item) {
      item.total = totalItemEntrada(item);
      this.subtotal = resumoEntrada(this.produtosL, this.acrescimo, this.desconto).subtotal;

      this.calcularTotais();
    },
    calcularTotais() {
      const resumo = resumoEntrada(this.produtosL, this.acrescimo, this.desconto);
      this.subtotal = resumo.subtotal;
      this.total = resumo.total;
    },
    onInputQuantidade(valorDigitado, item) {
      let quantidade = Math.max(0, Math.floor(Number(valorDigitado || 0)));
      if (item.quantidadePendente && quantidade > item.quantidadePendente) {
        quantidade = item.quantidadePendente;
      }
      const index = this.produtosL.findIndex((produto) => produto.index === item.index);
      const itemAtualizado = index >= 0 ? this.produtosL[index] : item;

      this.$set(itemAtualizado, "quantidade", quantidade);
      if (itemAtualizado.IdPedidoItem != null && itemAtualizado.quantidadeOriginalPedido) {
        const desconto = descontoProporcionalItemPedido(itemAtualizado, quantidade);
        this.$set(itemAtualizado, "desconto", desconto);
        this.$set(
          itemAtualizado,
          "descontoLocal",
          desconto.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      }
      this.calcularSubtotais(itemAtualizado);

      if (index >= 0) {
        this.$set(this.produtosL, index, itemAtualizado);
      }
    },
    async enviar() {
      const centrosOk = this.validarCentroCustoItens();
      if (!centrosOk && this.pedidosNF == null) {
        this.errorMessageValue =
          "Preencha o Centro de Custo em todos os itens.";
        this.errorMessage = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.errorMessageValue = "Preencha todos os campos obrigatÃ³rios.";
        this.errorMessage = true;
        return;
      }
      if (
        this.total <= 0 ||
        this.produtosL == null ||
        this.produtosL.length == 0
      ) {
        this.errorMessageValue =
          "O valor total nÃ£o pode ser zero. Preencha os valores na lista de produtos!";
        this.errorMessage = true;
        return;
      }
      this.overlay = true;
      const resposta = await editarEntradaNFAsync(
        this.entradaNF.id,
        this.dataEmissao,
        this.numero,
        this.fornecedorSelected.id,
        this.condicaoPagamentoSelected.id,
        this.unidadeAdmSelected.id,
        this.observacao,
        this.desconto,
        this.acrescimo,
        this.subtotal,
        this.total,
        this.produtosL
      );
      if (resposta?.status && resposta.status != 200) {
        this.overlay = false;
        this.$alert(
          resposta.message || "",
          "Desculpe, falha na operaÃ§Ã£o!",
          "error"
        );
      } else {
        this.overlay = false;
        this.$router.push({ path: '/entradaNF', query: this.$route.query });
      }
    },

    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataEmissao = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataEmissao(date) {
      this.dataEmissao = date;
    },

    addProduto: function (e) {
      this.showModal = true;
    },
    selecionarPedido() {
      this.showModalFornecedor = true;
    },
    onAdicionarPedido(payload) {
      if (!payload || !payload.itens || payload.itens.length === 0) {
        this.showModalFornecedor = false;
        return;
      }
      if (this.fornecedorSelected && Number(this.fornecedorSelected.id) !== Number(payload.fornecedorId)) {
        this.errorMessageValue = "A entrada de nota fiscal deve permanecer vinculada ao fornecedor selecionado.";
        this.errorMessage = true;
        return;
      }
      const duplicado = payload.itens.find((item) =>
        this.produtosL.some((produto) =>
          produto.IdPedidoItem != null &&
          Number(produto.IdPedidoItem) === Number(item.id) &&
          Number(produto.idPedido) === Number(item.idPedido || this.pedidosNF?.pedidoId) &&
          this.tipoPedidoValor(produto.tipoPedido) === this.tipoPedidoValor(item.tipoPedido || this.pedidosNF?.tipoPedido)
        )
      );
      if (duplicado) {
        this.errorMessageValue =
          "O item selecionado jÃ¡ foi adicionado a esta entrada de nota fiscal.";
        this.errorMessage = true;
        return;
      }
      payload.itens.forEach((item) => {
        const produto = this.criarProdutoPedido(item);
        this.produtosL.push(produto);
        this.calcularSubtotais(produto);
      });
      this.calcularTotais();
      this.showModalFornecedor = false;
    },
    tipoPedidoValor(tipoPedido) {
      if (tipoPedido === 1 || tipoPedido === "1" || tipoPedido === "PC") return 1;
      if (tipoPedido === 2 || tipoPedido === "2" || tipoPedido === "PA") return 2;
      return null;
    },
    criarProdutoPedido(item) {
      const centroCusto = this.findCentroCusto(item.centroCusto) || {};
      const quantidadeOriginal = quantidadeOriginalPedido(item);
      const descontoOriginal = descontoOriginalItemPedido(item);
      const desconto = descontoProporcionalItemPedido(
        {
          ...item,
          descontoOriginalItem: descontoOriginal,
          quantidadeOriginalPedido: quantidadeOriginal,
        },
        item.quantidade
      );
      const produto = {
        IdPedidoItem: item.id,
        idPedido: item.idPedido || this.pedidosNF?.pedidoId,
        tipoPedido: this.tipoPedidoValor(item.tipoPedido || this.pedidosNF?.tipoPedido),
        idProduto: item.idProduto,
        idSolicitacaoItem: item.idSolicitacaoItem,
        produto: item.produto,
        codigo: item.codigo,
        unidadeMedida: item.unidadeMedida,
        quantidade: item.quantidade,
        quantidadePendente: item.quantidade,
        quantidadeOriginalPedido: quantidadeOriginal,
        descontoOriginalItem: descontoOriginal,
        centroCustoSelected: this.findCentroCusto(item.centroCusto),
        idCentroCusto: centroCusto.id,
        centroCusto: item.centroCusto,
        valorUnitario: item.valorUnitario,
        desconto,
        valorUnitarioLocal: parseFloat(item.valorUnitario),
        descontoLocal: desconto,
        centroCustoErro: false,
        editingCentroCusto: false,
        total: 0,
        index:
          this.produtosL.length === 0
            ? 0
            : Math.max(...this.produtosL.map((p) => p.index)) + 1,
      };
      produto.total = totalItemEntrada(produto);
      return produto;
    },
    removeProduto(index) {
      this.produtosL = this.produtosL.filter((p) => p.index != index);
      if (this.produtosL.length > 0) {
        this.produtosL.forEach((item) => {
          this.calcularSubtotais(item);
        });
        this.calcularTotais();
      } else {
        this.subtotal = 0;
        this.total = 0;
      }
    },
    changeProduto(index, centroCusto) {
      this.produtosL[index].idCentroCusto = centroCusto.id;
      this.produtosL[index].centroCusto = centroCusto.descricao;
    },
    findFornecedor(fornecedorId) {
      return this.filteredFornecedor.find((f) => f.id === fornecedorId);
    },
    findCentroCusto(centroCusto) {
      return this.centrosCusto.find((c) => c.descricao === centroCusto);
    },
    findPagamento(idPagamento) {
      return this.condicoes.find((c) => c.id === idPagamento);
    },
    findUnidadeAdm(idUnidadeAdm) {
      return this.locais.find((l) => l.id === idUnidadeAdm);
    },
    async obterListas() {
      await this.atualizarListaProdutos();
      if (!this.pedidosEntrada || this.pedidosEntrada.length === 0) {
        await this.atualizarPedidosEntrada(this.entradaNF && this.entradaNF.id);
      }
    },
    validarCentroCustoItens() {
      const itensInvalidos = this.produtosL.filter(
        (i) => !i.centroCusto || !i.idCentroCusto
      );
      this.produtosL.forEach((i) => {
        i.centroCustoErro = !i.centroCusto || !i.idCentroCusto;
      });

      return itensInvalidos.length === 0;
    },
  },
  created: function () {
    this.readOnly = !getUserPermission(20);
    this.obterListas();
    this.fornecedorSelected = this.findFornecedor(this.entradaNF.idFornecedor);
    this.condicaoPagamentoSelected = this.findPagamento(
      this.entradaNF.idCondicaoPagamento
    );
    this.unidadeAdmSelected = this.findUnidadeAdm(this.entradaNF.idUnidadeAdm);
    this.numero = this.entradaNF.numero;
    this.dataEmissao = this.entradaNF.dataEmissao;
    this.informacoesAdicionais = this.entradaNF.informacoesAdicionais;

    this.acrescimoLocal = this.entradaNF.acrescimo;
    this.descontoLocal = this.entradaNF.desconto;
    this.acrescimo = this.entradaNF.acrescimo;
    this.desconto = this.entradaNF.desconto;

    this.entradaNF.itens.forEach((item) => {
      const desconto = Number(item.desconto || 0);
      const produto = {
        id: item.id,
        IdPedidoItem: item.idPedidoItem,
        idPedido: item.idPedido || this.pedidosNF?.pedidoId,
        tipoPedido: this.tipoPedidoValor(item.tipoPedido || this.pedidosNF?.tipoPedido),
        idProduto: item.idProduto,
        idSolicitacaoItem: item.idSolicitacao,
        produto: item.produto,
        codigo: "",
        unidadeMedida: "",
        quantidade: item.quantidade,
        centroCusto: item.centroCusto,
        idCentroCusto: item.idCentroCusto,
        centroCustoSelected: this.findCentroCusto(item.centroCusto),
        valorUnitario: item.valorUnitario,
        desconto,
        valorUnitarioLocal: parseFloat(item.valorUnitario),
        descontoLocal: desconto,
        centroCustoErro: false,
        editingCentroCusto: false,
        total: 0,
        index:
          this.produtosL.length === 0
            ? 0
            : Math.max(...this.produtosL.map((p) => p.index)) + 1,
      };

      produto.total = totalItemEntrada(produto);
      this.produtosL.push(produto);
      this.calcularSubtotais(produto);
    });
    this.calcularTotais();
  },
  components: {
    Produto,
    Fornecedor,
  },
};
</script>


